const MESES = [
  'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
  'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'
];

// A API devolve data_encerramento como ISO em UTC (mesmo efeito do mysql2
// reconstruindo com timezone:'-04:00' fixo, ver database.js) — subtrai as
// 4h de volta e lê como se fosse UTC pra chegar no horário que foi
// realmente configurado. Mesma conta usada em ConfigurarEnqueteForm.js
// (paraPartesCorumba) pra preencher os campos de edição.
export function formatarDataEncerramento(isoUtc) {
  if (!isoUtc) return '';
  const data = new Date(isoUtc);
  if (Number.isNaN(data.getTime())) return '';

  const comOffset = new Date(data.getTime() - 4 * 60 * 60 * 1000);
  const dia = String(comOffset.getUTCDate()).padStart(2, '0');
  const mes = MESES[comOffset.getUTCMonth()];
  const ano = comOffset.getUTCFullYear();
  const hora = String(comOffset.getUTCHours()).padStart(2, '0');
  const minuto = String(comOffset.getUTCMinutes()).padStart(2, '0');

  return `${dia} de ${mes.charAt(0).toUpperCase()}${mes.slice(1)} de ${ano} às ${hora}:${minuto}`;
}
